export const getConsentHeaders = (): Record<string, string> => ({});

export const getConsentJsonHeaders = (): Record<string, string> => ({
    "Content-Type": "application/json",
});
